import React from 'react';

export const SpotPopoverContext = React.createContext({
  hidePopover: (): void => void 0,
  popoverVisible: (): boolean => {
    return false;
  },
});
